export enum Colour {
    Primary = "primary",
    Secondary = "secondary",
    Alt = "alt",
    Allhires = "allhires",
    White = "white",
}

export enum LogonStatus {
    FAIL = 0,
    PASS = 1,
    LOCKED = 3,
    DISABLED = 4,
    EXPIRED = 5,
}

export enum UserType {
    Anonymous = 0,
    Admin = 1,
    Agency = 2,
    Candidate = 3
}